export default "__VITE_ASSET__Cp2Bjw25__"